<template>
    <div class="container mt-4">
        <Portfolio/>
    </div>
</template>

<script>

    import UserMixin from "@/lib/mixins/UserMixin";
    import Portfolio from "./App/Portfolio"

    export default {
        name: 'Home',
        mixins: [
            UserMixin
        ],
        components: {
            Portfolio
        }
    }
</script>
